import axios from 'axios';
import { ElMessage, ElMessageBox } from 'element-plus';
import router from '@/router';

// 创建axios实例
const request = axios.create({
    baseURL: 'https://sharpofscience.top/academi_village/api/v1',  // 后端API地址
    // baseURL: 'http://sharpofscience.top:9336/api/v1',  // 后端API地址
    // baseURL: 'http://192.168.5.107:8083/api/v1',  // 后端API地址
    timeout: 10000
});

// 请求拦截器
request.interceptors.request.use(
    config => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
request.interceptors.response.use(
    response => {
        return response.data;
    },
    error => {
        // 处理错误响应
        const response = error.response;
        let message = '请求失败';
        let errcode = null;
        
        if (response?.data?.detail) {
            if (typeof response.data.detail === 'object') {
                message = response.data.detail.msg;
                errcode = response.data.detail.errcode;
            } else {
                message = response.data.detail;
            }
        }

        if (errcode === ErrCode.USER_NOT_ACTIVE) {
            ElMessageBox.alert('发表一条导师评价即可激活账号，查看所有导师评价。', '账号未激活', {
                confirmButtonText: '朕知道了',
                showClose: false,
                center: true,
            });
            return;
        }

        // 处理特定错误码
        switch (response?.status) {
            case 401:
                // 未授权,可能需要重新登录
                localStorage.removeItem('token');
                router.push('/login');
                break;
            case 403:
                message = message || '没有权限执行此操作';
                break;
            case 404:
                message = message || '请求的资源不存在';
                break;
            case 429:
                message = '请求过于频繁,请稍后再试';
                break;
        }

        ElMessage.error(message);
        return Promise.reject(error);
    }
);

const ErrCode = {
    USER_NOT_ACTIVE: "USER_NOT_ACTIVE"
};

export default request; 